"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("./context");

var _useSession = _interopRequireDefault(require("./useSession"));

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var loadWebfontsWithHtmlApi = function loadWebfontsWithHtmlApi(fonts) {
  return Promise.all(fonts.map(function (_ref) {
    var family = _ref.family,
        weight = _ref.weight,
        style = _ref.style;
    return document.fonts.load([style, weight, '1em', family].join(' '));
  }));
};

var loadWebfontsWithFallback = function loadWebfontsWithFallback(fonts) {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./webfontsPolyfill'));
  }).then(function (_ref2) {
    var webfontsPolyfill = _ref2.default;
    return webfontsPolyfill(fonts);
  });
};

var loadWebfonts = function loadWebfonts(fonts) {
  return typeof window !== 'undefined' && 'fonts' in document ? loadWebfontsWithHtmlApi(fonts) : loadWebfontsWithFallback(fonts);
};

var useImmutableProp = function useImmutableProp(x) {
  var _useState = (0, _react.useState)(x),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      y = _useState2[0];

  return y;
}; // eslint-disable-next-line react/prop-types


var StagedFontsProvider = function StagedFontsProvider(_ref3) {
  var _ref3$pluginOptions = _ref3.pluginOptions,
      fonts = _ref3$pluginOptions.fonts,
      alwaysLoadCriticalsFirstProp = _ref3$pluginOptions.alwaysLoadCriticalsFirst,
      children = _ref3.children;
  var alwaysLoadCriticalsFirst = useImmutableProp(alwaysLoadCriticalsFirstProp);
  /* eslint-disable react-hooks/rules-of-hooks */

  var _ref4 = alwaysLoadCriticalsFirst ? (0, _react.useState)(0) : (0, _useSession.default)(_constants.STAGED_FONTS_STORAGE_KEY, 0),
      _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
      stage = _ref5[0],
      setStage = _ref5[1];
  /* eslint-enable react-hooks/rules-of-hooks */


  (0, _react.useEffect)(function () {
    return void (stage === 0 && loadWebfonts(fonts).then(function () {
      return setStage(1);
    }));
  }, [fonts, stage, setStage]);
  var api = (0, _react.useMemo)(function () {
    return {
      stage: stage
    };
  }, [stage]);
  return /*#__PURE__*/_react.default.createElement(_context.Provider, {
    children: children,
    value: api
  });
};

var FontDescription = process.env.NODE_ENV !== "production" ? _propTypes.default.shape({
  critical: _propTypes.default.bool,
  family: _propTypes.default.string.isRequired,
  files: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string.isRequired
  }).isRequired).isRequired,
  style: _propTypes.default.any,
  weight: _propTypes.default.any
}) : {};
process.env.NODE_ENV !== "production" ? StagedFontsProvider.propTypes = {
  children: _propTypes.default.node,
  pluginOptions: _propTypes.default.shape({
    alwaysLoadCriticalsFirst: _propTypes.default.bool,
    fonts: _propTypes.default.arrayOf(FontDescription)
  }).isRequired
} : void 0;
var _default = StagedFontsProvider;
exports.default = _default;